import React, { useState, useRef, useEffect} from 'react'
import PropTypes from 'prop-types'
import {
  Nav, Navbar,
  Container, Col, Row, Modal, NavDropdown 
} from 'react-bootstrap'
import config from 'app/config'
import { v4 as uuidv4 } from 'uuid'
import { publicIpv4 } from 'public-ip'
import DeviceDetector from 'device-detector-js'
import Cookies from 'js-cookie'

const PublicLayout = ({ children, location, clickFooterButton }) => {
  const ref = useRef(null);
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const [menu, setMenu] = useState("");
  const scrollTop = () =>{   
    ref.current?.scrollIntoView({behavior: 'smooth'});
  };
  const [userPos, setUserPos] = useState({lat: null, long: null})
  const geolocationAPI = navigator.geolocation;

  const handleClickFooterButton = (botton_name, button_url) => {
    clickFooterButton(botton_name, button_url);
  }

  useEffect(() => {
    geolocationAPI.getCurrentPosition((pos) => {
      const newUserPos = { 
        lat: pos.coords.latitude,
        long: pos.coords.longitude,
      };
      if (typeof Cookies.get('loc') === 'undefined') {
        Cookies.set('loc', JSON.stringify(newUserPos), {
          path: '',
          sameSite: 'strict',
          secure: true
        })
      }
      setUserPos(newUserPos)
    }, (err) => {
      console.log(err);
    });
    setMenu(location.pathname)
  }, [])

  const getMenu = (location) => {
    setMenu(location)
  }

  const deviceDetector = new DeviceDetector()
  const userAgent = navigator.userAgent
  const parse = deviceDetector.parse(userAgent)

  config.tracker_data = {
    ...config.tracker_data,
    cookie_id: uuidv4(),
    screen_height: screen.height,
    screen_width: screen.width,
    operating_system: parse.os.name,
    browser_name: parse.client.name,
    device_type: parse.device.type,
    device_brand: parse.device.brand,
    referrer: document.referrer,
  }

  publicIpv4().then((result) => {
    config.tracker_data = {
      ...config.tracker_data,
      ip_address: result
    }
    
    if (typeof Cookies.get('sp') === 'undefined') {
      Cookies.set('sp', JSON.stringify(config.tracker_data), {
        path: '',
        sameSite: 'strict',
        secure: true
      })
    }
  })

  return (
    <div className="app main-public">
      <div id="yield" className="app-main-public-body">
        <Navbar sticky="top" expand="lg" className="wrapper-menu">
          <Container>
            <Navbar.Brand>
              <a href="/">
                <img className="navbar-logo" src="/assets/logo/logo.png" alt="Situs Informasi SIPLah" />
              </a>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="navbarScroll" onClick={() => setIsOpenMenu(!isOpenMenu)}>
              {!isOpenMenu ?
                <div className="display-flex align-items-center">
                  <b className="font-size-14">Menu</b>
                  <span className="material-symbols-outlined font-bold m-l-10">
                    menu
                  </span>
                </div> 
                :
                <div className="display-flex align-items-center">
                  <b className="font-size-14">Tutup</b>
                  <span className="material-symbols-outlined font-bold m-l-10">
                    close
                  </span>
                </div>
              }
            </Navbar.Toggle>
            <Navbar.Collapse id="navbarScroll">
              <Nav className="me-auto">
                <Nav.Link href="/" className={menu === "/" ? "active" : ""} onClick={() => getMenu('/')}>
                  <div className="text"><b>Beranda</b></div>
                </Nav.Link>
                <Nav.Link href="/satuan-pendidikan" className={menu === "/satuan-pendidikan" ? "active" : ""} onClick={() => getMenu('/satuan-pendidikan')}>
                  <div className="text"><b>Satuan Pendidikan</b></div>
                </Nav.Link>
                <Nav.Link href="/penyedia-barang-jasa" className={menu === "/penyedia-barang-jasa" ? "active" : ""} onClick={() => getMenu('/penyedia-barang-jasa')}>
                  <div className="text"><b>Penyedia</b></div>
                </Nav.Link>
              </Nav>
              <Nav>
                <a className={`nav-link ${menu === "/searchs" ? "active" : ""}`} href={`${config.search_url}?keyword=&latitude=${userPos?.lat}&longitude=${userPos?.long}&sort=RELEVANCE`} target="_blank" onClick={() => getMenu(location.pathname)}>
                  <div className="text">
                    <b className="display-flex align-items-center">
                      Cari Produk 
                      <span className="material-symbols-outlined font-bold m-l-5 d-none d-md-block">
                        search
                      </span>
                    </b>
                  </div>
                </a>
                <a className={`nav-link ${menu === "/info-berita" ? "active" : ""}`} href="/info-berita" onClick={() => getMenu('/info-berita')}>
                  <div className="text">
                    <b className="display-flex align-items-center">
                      Info & Berita
                    </b>
                  </div>
                </a>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        {isOpenMenu ? <span className="screen-darken"></span> : null}
        <div style={{height: '50px', position: 'absolute', top: '-50px', pointerEvents: 'none'}}></div>
        <div ref={ref} style={{scrollMargin:'65px'}}>
          {children}
        </div>
        <footer className="main-footer">
          <div className="footer-top">
            <Container className="p-t-44 p-b-44">
              <Row>
                <Col lg={6} md={12} sm={12} xs={12}>
                  <img className="navbar-logo" src="/assets/logo/logo-white.png" alt="kemdikbud" />
                  <div className="text-white m-t-20 m-b-36 font-size-22 width-400">
                    <b>Situs informasi resmi pengadaan barang dan jasa satuan pendidikan Kemendikdasmen</b>
                  </div>
                  <div className="text-white m-b-12">Ikuti kami di</div>
                  <div className="social-links m-b-44">
                    <a href="https://www.facebook.com/SIPLah-Kemendikbud-103634151134921/" target="_blank" rel="noreferrer" className="text-white font-size-20"><img src="/assets/homepage/fb.svg" alt="facebook"/></a>
                    <a href="https://twitter.com/Kemdikbud_RI" target="_blank" rel="noreferrer" className="text-white font-size-20 m-l-12"><img src="/assets/homepage/tw.svg" alt="twitter"/></a>
                    <a href="https://www.instagram.com/siplah_dikbud/" target="_blank" rel="noreferrer" className="text-white font-size-20 m-l-12"><img src="/assets/homepage/ig.svg" alt="instagram"/></a>
                    <a href="https://www.youtube.com/c/SIPLahKemdikbud" target="_blank" rel="noreferrer" className="text-white font-size-20 m-l-12"><img src="/assets/homepage/yt.svg" alt="youtube"/></a>
                  </div>
                </Col>
                <Col lg={6} md={12} sm={12} xs={12}>
                  <Row>
                    <Col md={4} sm={4} xs={12}>
                      <b className="text-white heading-footer font-size-14">NAVIGASI</b>
                      <div className="m-t-12"><a className="text-white-smoke footer-link" href="/">Beranda</a></div>
                      <div className="m-t-12"><a className="text-white-smoke footer-link" href="/satuan-pendidikan">Satuan Pendidikan</a></div>
                      <div className="m-t-10"><a className="text-white-smoke footer-link" href="/penyedia-barang-jasa">Penyedia</a></div>
                      <div className="m-t-10"><a className="text-white-smoke footer-link" href={`${config.search_url}?keyword=&latitude=${userPos?.lat}&longitude=${userPos?.long}&sort=RELEVANCE`} target="_blank">Cari Produk</a></div>
                      <div className="m-t-12"><a className="text-white-smoke footer-link" href="/info-berita">Info & Berita</a></div>
                    </Col>
                    <Col md={4} sm={4} xs={12} className="gap-top-44">
                      <b className="text-white heading-footer font-size-14">INFO & BERITA</b>
                      <div className="m-t-12"><a className="text-white-smoke footer-link" href="https://siplah.kemendikdasmen.go.id/info-berita/e1263f32-c56a-4122-b438-243753df6164">Pengumuman</a></div>
                      <div className="m-t-12"><a className="text-white-smoke footer-link" href="https://pusatinformasi.siplah.kemendikdasmen.go.id/hc/sections/36585401642393-Panduan-Berbelanja-di-SIPLah" target="_blank">Pelajari SIPLah</a></div>
                      <div className="m-t-12"><a className="text-white-smoke footer-link" href="https://www.instagram.com/siplah_dikbud/?hl=en" target="_blank">Ikuti SIPLah</a></div>
                      <div className="m-t-12"><a className="text-white-smoke footer-link" href="https://siplah.kemendikdasmen.go.id/index.php/banper" target="_blank">Bantuan Pemerintah</a></div>
                    </Col>
                    <Col md={4} sm={4} xs={12} className="gap-top-44">
                      <b className="text-white heading-footer font-size-14">LAINNYA</b>
                      <div className="m-t-12"><a className="text-white-smoke footer-link" href="https://pengaduan.ult.kemendikdasmen.go.id/hc/requests/new" target="_blank" onClick={() => handleClickFooterButton('CONTACT_US', 'https://pengaduan.ult.kemendikdasmen.go.id/hc/requests/new')}>Hubungi Kami</a></div>
                      <div className="m-t-12"><a className="text-white-smoke footer-link" href={config.daspeng_url} target="_blank" onClick={() => handleClickFooterButton('DASHBOARD_PENGAWASAN', config.daspeng_url)}>Dasbor Pengawasan</a></div>
                      <div className="m-t-12 m-b-12"><a className="text-white-smoke footer-link" href="http://tkdn.kemenperin.go.id" target="_blank" onClick={() => handleClickFooterButton('TKDN_KEMENPERIN', 'http://tkdn.kemenperin.go.id')}>TKDN Kementerian Perindustrian</a></div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </div>
          <hr className="hr"/>
          <Container>
            <Row>
              <Col md={11} sm={11} xs={12}>
                <div className="copyright text-white d-none d-sm-block m-t-24 m-b-24">Hak Cipta <b>Kementerian Pendidikan, Kebudayaan, Riset, dan Teknologi Republik Indonesia</b> © 2022</div>
                <div className="copyright text-white d-block d-sm-none m-t-24 m-b-24"><center>Hak Cipta <b>Kementerian Pendidikan, Kebudayaan, Riset, dan Teknologi Republik Indonesia</b> © 2022</center></div>
              </Col>
              <Col md={1} sm={1} xs={12} className="text-arrow-footer">
                <a onClick={scrollTop}>
                  <span className="material-symbols-outlined text-white gap-arrow-footer">
                    arrow_upward
                  </span>
                </a>
              </Col>
            </Row>
          </Container>
        </footer>
      </div>
    </div>
  )
}

PublicLayout.propTypes = {
  children: PropTypes.node,
  socmedData: PropTypes.object,
  menuList: PropTypes.object,
}

export default PublicLayout
